<template>
  <SplitViewTemplate
    :screenConfig="setScreenConfig"
    :backButtonRoute="'/settings/company'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
  />
</template>
<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      formModel: {
        Code: "",
        Name: "",
        Inactive: true,
        IsSystemDefined: "",
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
    };
  },
  computed: {
    setScreenConfig() {
      const config = {
        title: "Branch Type",
        pageRoute: "/branch-type",
        saveEndPoint: "Save_BranchType",
        recordEndPoint: "BranchType",
        exportFileName: "Branch Type List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BranchType",
              filter: "",
              select: ["RecordId", "Code", "Name", "Inactive", "IsSystemDefined"],
              serverPaging: true,
              allowGrouping: false,
              sort: [{ selector: "Code", desc: false }],
            },
            rowSelect: {
              view: this,
              page: "branch-type",
              mode: "review",
              idProperty: "RecordId",
              idMode: "Guid",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: false,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/branch-type/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              dataField: "Code",
              sortOrder: "asc",
              sortIndex: 0,
              allowHiding: false,
              alignment: "left",
              exportFields: [
                {
                  dataField: "Code",
                  label: "Branch Type Code",
                },
                {
                  dataField: "Name",
                  label: "Branch Type Name",
                },
              ],
            },
            {
              screenField: "Name",
              dataField: "Name",
            },
            {
              screenField: "Status",
              dataField: "Inactive",
              filterIndex: 0,
            },
          ],
          valueChangedEventListners: [],
        },
      };

      return config;
    },

    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                required: true,
                screenField: "Code",
                isPrimaryKeyField: true,
                // System-defined rows (BR-02): Code cannot be changed once created.
                // Server-side is the real guard (BranchTypeBusiness) — this is client convenience only.
                allowUpdate:
                  this.baseView.mode == "create"
                    ? true
                    : this.formModel.IsSystemDefined !== "Y",
                editorOptions: {
                  maxLength: 20,
                },
              },
              {
                dataField: "Name",
                required: true,
                screenField: "Name",
                editorOptions: {
                  maxLength: 200,
                },
              },
            ],
          },
        ],
      };

      return form;
    },
  },
};
</script>
